import {
    getAbandonedGiftDonorDetailsInitialValues,
    getDonorDetailsInitialValues,
} from "@qgiv/donation-form";

const getInitialValues = ({
    initialValuesSettings,
    savedValues = {},
    storedAbandonedGiftData = {},
    useAbandonedGiftData = false,
}) => {
    const initialValuesFromSettings = getDonorDetailsInitialValues(
        initialValuesSettings,
    );

    if (useAbandonedGiftData) {
        const initialValuesWithAbandonedGiftData =
            getAbandonedGiftDonorDetailsInitialValues({
                initialValuesFromSettings,
                storedAbandonedGiftData,
                savedValues,
            });
        return initialValuesWithAbandonedGiftData;
    }

    const initialValuesWithSavedValues = {
        ...initialValuesFromSettings,
        ...savedValues,
    };

    return initialValuesWithSavedValues;
};

export default getInitialValues;
